import React from 'react';
import type { ApiPlayer } from '@/api/dfs';

const CONFIG: Record<string, { pre: string; post: string; cls: string }> = {
  STARTING:     { pre: 'Starting', post: 'Started', cls: 'bg-green-600/20 text-green-400 ring-green-500/30' },
  BENCH:        { pre: 'Bench',    post: 'Bench',   cls: 'bg-yellow-600/20 text-yellow-400 ring-yellow-500/30' },
  NOT_IN_SQUAD: { pre: 'Out',      post: 'Out',     cls: 'bg-red-600/20 text-red-400 ring-red-500/30' },
};

interface AvailabilityBadgeProps {
  status: ApiPlayer['availability_status'];
  isLocked: boolean;
}

const AvailabilityBadge: React.FC<AvailabilityBadgeProps> = ({ status, isLocked }) => {
  if (!status || !(status in CONFIG)) return null;

  const cfg = CONFIG[status];
  const label = isLocked ? cfg.post : cfg.pre;

  return (
    <span className={`inline-flex flex-shrink-0 items-center justify-center whitespace-nowrap rounded px-1.5 py-0.5 text-badge font-semibold ring-1 ring-inset ${cfg.cls}`}>
      {label}
    </span>
  );
};

export default AvailabilityBadge;
